<template>
  <div :class="{'list-grid': positions && positions.length > 0 }">
    <div v-for="(item, index) in positions" :key="index" :class="[hasActions ? 'list-item' : 'list-item-readonly']">
      <!--
      <font-awesome-icon icon="box-open" class="entity-icon ml2"/>
      -->
      <div class="item-layout" @click.stop="edit(item)">
        <div class="lh-copy text-line-3">
          {{ item.title }}
        </div>
        <div class="items-details ml4 f6 bl b--near-white ph3" >
          <span class="text-secondary">объем </span><span>{{ fv(item.amount) }} <span class="text-secondary">{{ unitName(item.unit_id) }}</span></span>
          <!--
          <span class="text-secondary">ед. изм. </span><span>{{ unitName(item.unit_id) }} </span>
          -->
          <span class="text-secondary">цена ед. </span><span>{{ fp(item.price) }}</span>
        </div>
      </div>
      <div v-if="hasActions" class="flex flex-row justify-around bl b--near-white">
        <button v-if="actions.update" @click.stop="$emit('edit', item)" class="input-icon-button bg-light">
          <font-awesome-icon icon="edit" class="entity-icon"/>
        </button>
        <button v-if="actions.delete" @click.stop="$emit('delete', item )" class="input-icon-button secondary bg-light">
          <font-awesome-icon :icon="['far', 'trash-alt']" class="entity-icon"/>
        </button>
      </div>
      <div v-if="hasActions" class="ml2 bl b--near-white">
        <checkbox :value="item.id" :checked="selected.has(item.id)" @change="$emit('checkboxed', $event)"/>
      </div>
    </div>
  </div>
</template>

<script>
import { formatPrice, formatVolume } from '@/utils/format'
import Checkbox from '@/components/ui/Checkbox.vue'

export default {
  props: ['positions', 'actions', 'selected'],
  components: {
    Checkbox
  },
  computed: {
    hasActions () {
      return this.actions.update || this.actions.delete
    }
  },
  methods: {
    unitName (unitId) {
      return unitId && this.$store.getters['dict/unit'](unitId)
        ? this.$store.getters['dict/unit'](unitId).name
        : null
    },
    edit (item) {
      if (this.actions.update) {
        this.$emit('edit', item)
      }
    },
    fp (price) {
      return formatPrice(price)
    },
    fv (volume) {
      return formatVolume(volume)
    }
  }
}
</script>

<style lang="scss" scoped>
.list-grid {
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: 1fr;
  grid-gap: 1px;
  background-color: #eef2f6;
  padding-top: 1px;
  padding-bottom: 1px;
}
.list-item {
  display: grid;
  grid-template-columns: 1fr 90px 2.5rem;
  grid-column-gap: .5rem;
  grid-row-gap: 1rem;
  align-items: center;
  padding: .5rem .5rem .5rem .5rem;
  background-color: #FFFFFF;
  &:hover, :focus {
    background-color: #f6f7f9;
    cursor: pointer;
  }
}
.list-item-readonly {
  @extend .list-item;
  grid-template-columns: 1fr;
}
.item-layout {
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-template-rows: 1fr;
  grid-gap: 2px;
  align-items: center;
}
.item-layout-readonly {
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-template-rows: 1fr;
  grid-gap: 2px;
  align-items: center;
}
.items-details {
  display: grid;
  grid-template-columns: 5rem 1fr;
  grid-template-rows: 1fr;
  grid-gap: 2px;
}
</style>
